"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = KakaoMap;
exports.KakaoMapContext = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _hooks = require("../../hooks");

var _MapContainer = _interopRequireDefault(require("../MapContainer"));

var _constants = require("../../constants");

KakaoMap.propTypes = {
  apiUrl: _propTypes.default.string.isRequired,
  width: _propTypes.default.string,
  height: _propTypes.default.string,
  children: _propTypes.default.oneOfType([_propTypes.default.array, _propTypes.default.object])
};

var KakaoMapContext = _react.default.createContext({});

exports.KakaoMapContext = KakaoMapContext;

function KakaoMap(_ref) {
  var apiUrl = _ref.apiUrl,
      width = _ref.width,
      height = _ref.height,
      children = _ref.children,
      options = (0, _objectWithoutProperties2.default)(_ref, ["apiUrl", "width", "height", "children"]);

  var _useKakaoMapLoad = (0, _hooks.useKakaoMapLoad)({
    apiUrl: apiUrl
  }),
      kakaoMapObj = _useKakaoMapLoad.kakaoMapObj;

  var _useState = (0, _react.useState)(null),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      map = _useState2[0],
      setMap = _useState2[1];

  var loadHandler = (0, _react.useCallback)(function (element) {
    if (!kakaoMapObj || !element) return;
    var defaultLevel = _constants.defaultMapOptions.level,
        defaultLat = _constants.defaultMapOptions.lat,
        defaultLng = _constants.defaultMapOptions.lng;
    var _options$level = options.level,
        level = _options$level === void 0 ? defaultLevel : _options$level,
        _options$lat = options.lat,
        lat = _options$lat === void 0 ? defaultLat : _options$lat,
        _options$lng = options.lng,
        lng = _options$lng === void 0 ? defaultLng : _options$lng;
    var map = new kakaoMapObj.maps.Map(element, {
      level: level,
      center: new kakaoMapObj.maps.LatLng(lat, lng)
    });
    setMap(map);
  }, [kakaoMapObj]);
  return _react.default.createElement(_MapContainer.default, (0, _extends2.default)({
    width: width || _constants.defaultMapOptions.width,
    height: height || _constants.defaultMapOptions.height
  }, {
    ref: loadHandler
  }), _react.default.createElement(KakaoMapContext.Provider, {
    value: {
      kakaoMapObj: kakaoMapObj,
      map: map
    }
  }, children));
}